import { render } from "./ReservationRecord.vue?vue&type=template&id=51a61d02&scoped=true"
import script from "./ReservationRecord.vue?vue&type=script&lang=js"
export * from "./ReservationRecord.vue?vue&type=script&lang=js"

import "./ReservationRecord.vue?vue&type=style&index=0&id=51a61d02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a61d02"]])

export default __exports__